<!-- Dimensiones personalizadas col-per-2 y col-per-10 -->
<!-- para 720px col-xl-3 y col-xl-9 -->
<!-- para tablets col-md-4 y col-md-10 -->
<app-modal-temp></app-modal-temp>

<div class="main d-flex">
  <div class="sidebar-container col-per-2 col-xl-3 col-md-4">
    <app-sidebar></app-sidebar>
  </div>
  <div class="content-container col-12 col-per-10 col-xl-9 col-md-8">
    <div class="content-header">
      <app-profile-menu></app-profile-menu>
    </div>

    <router-outlet></router-outlet>
  </div>
</div>
